import COLLECTION_ORDER_LIST from "../symbols/collectionOrderList";
import { HttpRequestPost } from "../../service";
import { GetOrdersRequestModel } from "./collectOrders";

// TODO: Rename symbols, maybe
const collectionOrderListAction = () => ({
  type: COLLECTION_ORDER_LIST.COLLECTION_ORDER_LIST,
});
const collectionOrderListSuccessAction = (data: any) => {
  return {
    type: COLLECTION_ORDER_LIST.COLLECTION_ORDER_LIST_SUCCESS,
    payload: data,
  };
};
const collectionOrderListFailureAction = (data: any) => ({
  type: COLLECTION_ORDER_LIST.COLLECTION_ORDER_LIST_FAILURE,
  payload: {
    data,
  },
});
const clearOrderDetailAction = () => ({
  type: COLLECTION_ORDER_LIST.CLEAR_COLLECTION_ORDER_LIST,
});

const ordersSymbolsSetSelectedTabAction = (selected: number) => ({
  type: COLLECTION_ORDER_LIST.COLLECTION_ORDER_SET_SELECTED_TAB,
  payload: selected,
});

export function setSelectedCollectOrderTab(selected: number) {
  return (dispatch: any) => {
    dispatch(ordersSymbolsSetSelectedTabAction(selected));
  };
}

// TODO: Actions
export function GetCollectionOrderList(
  url: string = "open",
  body: GetOrdersRequestModel
) {
  return (dispatch: any) => {
    dispatch(collectionOrderListAction());
    HttpRequestPost(
      `/collect/list/${url}`,
      dispatch,
      collectionOrderListSuccessAction,
      collectionOrderListFailureAction,
      true,
      body
    );
  };
}

export function clearCollectionList() {
  return (dispatch: any) => {
    dispatch(clearOrderDetailAction());
  };
}
